import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import api, { formatApiError } from "../api";
import { BrutalButton, BrutalCard, BrutalInput } from "../components/Brutal";
import { Package, EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-200px)] flex items-center justify-center py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-14 h-14 bg-white border border-[#c9a24a] rounded-xl shadow-sm flex items-center justify-center">
              <Package size={28} weight="bold" color="#c9a24a" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">ReUP</h1>
          </div>
        </div>

        <BrutalCard data-testid="forgot-password-card">
          {sent ? (
            <div className="text-center py-4" data-testid="forgot-password-sent">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#fbf6e7] border border-[#c9a24a] flex items-center justify-center">
                <EnvelopeSimple size={24} weight="bold" color="#c9a24a" />
              </div>
              <h2 className="text-xl font-semibold mb-2 tracking-tight">{t("auth.forgot_sent_title")}</h2>
              <p className="text-sm text-zinc-600 leading-relaxed">{t("auth.forgot_sent_body")}</p>
              <p className="text-xs text-zinc-400 mt-3">{t("auth.forgot_sent_expiry")}</p>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-semibold mb-2 tracking-tight">{t("auth.forgot_title")}</h2>
              <p className="text-sm text-zinc-600 mb-6">{t("auth.forgot_hint")}</p>
              <form onSubmit={onSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2">{t("common.email")}</label>
                  <BrutalInput
                    data-testid="forgot-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    autoFocus
                    required
                  />
                </div>
                <BrutalButton
                  type="submit"
                  size="lg"
                  disabled={loading}
                  className="w-full"
                  data-testid="forgot-submit-button"
                >
                  {loading ? t("auth.forgot_sending") : t("auth.forgot_submit")}
                </BrutalButton>
              </form>
            </>
          )}
          <p className="text-sm text-zinc-600 mt-6 text-center">
            <Link to="/login" className="inline-flex items-center gap-1 font-medium text-[#8a6a1c] hover:underline" data-testid="back-to-login-link">
              <ArrowLeft size={14} /> {t("auth.back_to_login")}
            </Link>
          </p>
        </BrutalCard>
      </div>
    </div>
  );
}
